import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {
  renderCheckboxes,
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../common/inputField';
import { toRomanNumeral } from '../../../utils/common';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../actions';

const PreviousObstetricHistory = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`patientHistory.${name}`, value));
  };

  const handleCheckboxChange = (e, index) => {
    const { name, checked } = e.target;

    const updatedCheckboxes =
      patientData.patientHistory.previousObstetricHistory.type;
    updatedCheckboxes[index].checked = checked;
    dispatch(
      setPatientData(
        `patientHistory.previousObstetricHistory.type`,
        updatedCheckboxes,
      ),
    );
  };

  const handlePregnancyChange = (e, index, key) => {
    let value = e.target.value;
    if (key === 'conception' && value === 'Select') {
      value = '';
    }
    const updatedPregnancy =
      patientData.patientHistory.previousObstetricHistory.pregnancy;
    updatedPregnancy[index][key] = value;
    dispatch(
      setPatientData(
        `patientHistory.previousObstetricHistory.pregnancy`,
        updatedPregnancy,
      ),
    );
  };

  return (
    <React.Fragment>
      <p className="lead">PREVIOUS OBSTETRIC HISTORY</p>

      {renderCheckboxes(
        patientData.patientHistory.previousObstetricHistory.type,
        handleCheckboxChange,
        '',
        'type',
      )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Year</TableCell>
              <TableCell>Conception</TableCell>
              <TableCell>Outcome</TableCell>
              <TableCell>Delivery</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {patientData.patientHistory.previousObstetricHistory.pregnancy.map(
              (preg, index) => (
                <TableRow key={index}>
                  <TableCell>{`${toRomanNumeral(index + 1)} Pregnancy`}</TableCell>
                  <TableCell>
                    {renderInputFieldWithoutLabel('year', preg.year, (e) =>
                      handlePregnancyChange(e, index, 'year'),
                    )}
                  </TableCell>
                  <TableCell>
                    {renderDropdownWithoutLabel(
                      'conception',
                      preg.conception,
                      ['Select', 'Sp', 'OI', 'IUI', 'IVF'],
                      handlePregnancyChange,
                      index,
                    )}
                  </TableCell>
                  <TableCell>
                    {renderInputFieldWithoutLabel(
                      'outcome',
                      preg.outcome,
                      (e) => handlePregnancyChange(e, index, 'outcome'),
                    )}
                  </TableCell>
                  <TableCell>
                    {renderInputFieldWithoutLabel(
                      'delivery',
                      preg.delivery,
                      (e) => handlePregnancyChange(e, index, 'delivery'),
                    )}
                  </TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default PreviousObstetricHistory;
